import React, { useEffect, useState } from 'react';
import './character-card.scss'
export default function CharacterRow(props: any) {
    const [loadedIndex, setLoadedIndex] = useState(0);
    const [start, setStart] = useState(false);
    const [titleLoaded, setTitleLoaded] = useState(false);
    let characters = [
        { imageSrc: 'Atlus.png', row: -100, col: 300, height: 300 },
        { imageSrc: 'BHB.png', row: -200, col: 106 },
        { imageSrc: 'Gabby.png', row: -141, height: 180, col: 250 },
        { imageSrc: 'GhoulSitters.png', row: -200, col: 106 },
        { imageSrc: 'Iris.png', row: -200, col: -132 },
        { imageSrc: 'JaKhari.png', row: -224, col: 430 },
        { imageSrc: 'H3Jungul.png', row: -122, col: -112, scaleX: -1, rotate: '28deg', height: 300 },
        { imageSrc: 'Kembe.png', row: 175, col: 350, zIndex: 1000, height: 250 },
        { imageSrc: 'LittleAgent.png', row: -200, col: -30 },
        { imageSrc: 'MFT.png', row: 193, col: -162.2, scaleX: '-1' },
        { imageSrc: 'Monarchs.png', row: 7, col: -100, height: 300, rotate: '-12deg' },
        { imageSrc: 'Phia.png', row: -131, col: 0, height: 250 },
        { imageSrc: 'Pookie.png', row: 250, col: -59, height: 120, scaleX: 1 },
        { imageSrc: 'Shake.png', row: -120, col: 160 },
    ]

    return (
        <div className="character-card" style={{
            '--card-scale': 94
        }}>
            <div style={{
                position: 'relative',
            }}>

                {/* <img src={`/login-images/${c.imageSrc}`} /> */}
                {characters.map((c, index) => {
                    return <Character imgSrc={`/login-images/${c.imageSrc}`}
                        onLoaded={() => {
                            setLoadedIndex(index + 1)
                        }}
                        itemLoaded={characters.length}
                        options={{
                            row: 125,
                            col: 140 * index + -100,
                            index
                        }} key={index} />
                })}
            </div>
        </div>
    )
}

function Character(props: {
    imgSrc: string,
    onLoaded: () => void,
    itemLoaded: number,
    options: {
        height?: number,
        zIndex?: number,
        index?: number, scaleX?: number, rotate?: number, row: number, col: number
    }
}) {
    const { options } = props;
    const [rotateOn, setRotateOn] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const all_delay = 1;
    useEffect(() => {
        if (loaded) {
            setTimeout(() => {
                setRotateOn(true)
            }, (((options.index + 1) * .5) + all_delay + 2) * 1000)
        }
    }, [loaded])
    return (<div style={{
        '--character-row': options.row,
        '--character-col': options.col,
        '--rotate': options.rotate,
        '--scaleX': options.scaleX,
        '--delay': `${1}s`,
        'pointerEvents': 'none',
        'zIndex': options.zIndex || 1,
    }} className={`character ${loaded && 'loaded'} ${rotateOn && 'rotate'}`} >
        {<img onLoad={() => {
            setLoaded(true);
            props.onLoaded()
        }} style={{
            '--height': options.height || '217',
            '--delay': options.index ? `${(.5) + 1}s` : null
        }} src={props.imgSrc} />}
    </div>);
}